import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum AddDocumentFormErrorStatesEnum {
    CreatePoIFailed = ErrorStateScheduleEnum.AddDocumentFormStatesStartIndex,
    CreateIdentityDetailFailed,
    CreatePoAFailed,
    CreateSelfieFailed,
    CreateOtherFailed,
    UpdateDocumentToInReviewFailed,
    UpdateDocumentToApprovedFailed,
    CreateCompanyPoAFailed,
    CreateCompanyDocumentFailed,
    CreateCompanyOtherDocumentFailed,
}
